import { render, staticRenderFns } from "./AcademyStaff.vue?vue&type=template&id=3d9dc0b5&scoped=true"
import script from "./AcademyStaff.vue?vue&type=script&lang=js"
export * from "./AcademyStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9dc0b5",
  null
  
)

export default component.exports